(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jl-ingredient-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jl-ingredient-tabs')) {
    class JLIngredientTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(
          this.querySelectorAll('[data-ingredient-tab]')
        );

        this.panels = Array.from(
          this.querySelectorAll('[data-ingredient-panel]')
        );

        this.handleClick =
          this.handleClick.bind(this);

        this.handleKeydown =
          this.handleKeydown.bind(this);

        this.handleBlockSelect =
          this.handleBlockSelect.bind(this);

        this.addEventListener(
          'click',
          this.handleClick
        );

        this.addEventListener(
          'keydown',
          this.handleKeydown
        );

        document.addEventListener(
          'shopify:block:select',
          this.handleBlockSelect
        );

        const initialTab =
          this.tabs.find(
            (tab) =>
              tab.getAttribute('aria-selected') ===
              'true'
          ) || this.tabs[0];

        if (initialTab) {
          this.activateTab(initialTab, false);
        }
      }

      disconnectedCallback() {
        this.removeEventListener(
          'click',
          this.handleClick
        );

        this.removeEventListener(
          'keydown',
          this.handleKeydown
        );

        document.removeEventListener(
          'shopify:block:select',
          this.handleBlockSelect
        );
      }

      handleClick(event) {
        const tab = event.target.closest(
          '[data-ingredient-tab]'
        );

        if (!tab || !this.contains(tab)) return;

        this.activateTab(tab, false);
      }

      handleKeydown(event) {
        const currentTab = event.target.closest(
          '[data-ingredient-tab]'
        );

        if (!currentTab) return;

        const currentIndex =
          this.tabs.indexOf(currentTab);

        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight') {
          nextIndex =
            (currentIndex + 1) % this.tabs.length;
        } else if (event.key === 'ArrowLeft') {
          nextIndex =
            (currentIndex - 1 + this.tabs.length) %
            this.tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = this.tabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();

        const nextTab = this.tabs[nextIndex];

        this.activateTab(nextTab, true);
      }

      handleBlockSelect(event) {
        if (!this.contains(event.target)) return;

        const selectedBlockId =
          event.detail && event.detail.blockId;

        if (!selectedBlockId) return;

        const selectedTab = this.tabs.find(
          (tab) =>
            tab.dataset.blockId === selectedBlockId
        );

        if (selectedTab) {
          this.activateTab(selectedTab, false);
        }
      }

      activateTab(selectedTab, moveFocus) {
        if (!selectedTab) return;

        const selectedPanelId =
          selectedTab.getAttribute('aria-controls');

        this.tabs.forEach((tab) => {
          const isActive = tab === selectedTab;

          tab.classList.toggle(
            'is-active',
            isActive
          );

          tab.setAttribute(
            'aria-selected',
            String(isActive)
          );

          tab.setAttribute(
            'tabindex',
            isActive ? '0' : '-1'
          );
        });

        this.panels.forEach((panel) => {
          const isActive =
            panel.id === selectedPanelId;

          panel.hidden = !isActive;
          panel.classList.remove('is-active');

          if (isActive) {
            void panel.offsetWidth;
            panel.classList.add('is-active');
          }
        });

        if (moveFocus) {
          selectedTab.focus();
        }
      }
    }

    customElements.define(
      'jl-ingredient-tabs',
      JLIngredientTabs
    );
  }

  } catch(e) { console.error(e); }
})();
})();
